import { render, staticRenderFns } from "./CrownFilledIcon.vue?vue&type=template&id=ba89fd00&scoped=true"
import script from "./CrownFilledIcon.vue?vue&type=script&lang=js"
export * from "./CrownFilledIcon.vue?vue&type=script&lang=js"
import style0 from "./CrownFilledIcon.vue?vue&type=style&index=0&id=ba89fd00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba89fd00",
  null
  
)

export default component.exports